import { useParams } from 'react-router'
import TeamMatchStat from '../stories/TeamMatchStat/TeamMatchStat'
import { Match, useMatches, useTeamMatchHistory } from './api'
import classes from './Matches.module.css'
import { Typography } from '../common/typography'
import Result from '../stories/Result/Result'
import clsx from 'clsx'
import { useMediaQuery } from '@mantine/hooks'

export default function MatchHistory() {
  const isDesktop = useMediaQuery('(min-width: 800px)')
  const { competitionId, team1_id, team2_id } = useParams()
  const { data: match_history } = useTeamMatchHistory({
    competition_id: Number(competitionId),
    team1_id: Number(team1_id),
    team2_id: Number(team2_id),
  })

  const { data: matchesBetweenTeams } = useMatches({
    competition_id: Number(competitionId),
    team_id: Number(team1_id),
    other_team_id: Number(team2_id),
  })

  return (
    <div
      className={clsx(classes.headToHeadContainer, {
        [classes.headToHeadContainerMobile]: !isDesktop,
      })}
    >
      <TeamMatchStat match_history={match_history} />
      <div className={classes.headToHeadMatchesContainer}>
        <Typography fc={{ light: 'black', dark: 'gray-3' }} fw={500} lh="125">
          Matches
        </Typography>
        {matchesBetweenTeams
          .filter((m) => m.round_status === 'ended')
          .map((match: Match) => (
            <Result
              key={match.match_id}
              match={match}
              baseLink={`/competitions/${competitionId}/matches/${match.match_id}`}
            />
          ))}
      </div>
    </div>
  )
}
